<template>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 flex justify-between">
                <h1 class="text-2xl font-bold">Attivita timesheet</h1>

                <div class="flex flex-col w-1/4">
                    <Field :label-visible="false" @update:modelValue="lista.debounceSearch" v-model="lista.search"
                           placeholder="Cerca"></Field>
                </div>

                <NextButton component="router-link" :to="{name:'CreaAttivitaTimesheet'}"
                            class="py-1 px-3">
                    Nuovo
                </NextButton>
            </div>

            <div v-show="response_message.length" :class="[esito ? 'bg-next-bri' : 'bg-next-orange']"
                 class="text-white p-3 mb-3 flex justify-between items-center">
                {{ response_message }}
                <i class="icon-x cursor-pointer" @click="response_message = ''"></i>
            </div>

            <div class="flex justify-end">
                <Paginator class="" :pagination="lista.paginate"></Paginator>
            </div>
            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4"
                           v-model:cols="cols"
                           :rows="lista.rows" @order-update="lista.updateCols">
                    <template v-for="(c, j) in lista.rows" :key="j" v-slot:[`td_${j}_3`]="context">
                        <router-link
                            :to="{name:'DettaglioAttivitaTimesheet', params:{id:context.context.row.id}}"
                            class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></router-link>
                    </template>
                </NextTable>
            </div>
            <InfiniteLoading @infinite="lista.fetchNextPage"
                             :identifier="lista.infiniteIdentifier" style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altre attività.</div>
                </template>
            </InfiniteLoading>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Loading from "@/components/Loading.vue";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Checkbox from "@/components/Checkbox.vue";
import draggable from 'vuedraggable'
import {mapGetters} from 'vuex';
import Lista from "@/setup/ListaCerca";
import Paginator from "@/components/Paginator.vue";
import businessUnitAttivitaTimesheetVociSpesaManager from "@/api/BusinessUnitAttivitaTimesheetVociSpesaManager";

@Options({
    name: 'AttivitaTimesheet',
    components: {
        Paginator,
        Checkbox,
        MultiselectOption, NextButton,
        Loading,
        Field,
        NextTable,
        InfiniteLoading,
        draggable
    },
    props: {
        id: {
            type: [String, Number],
            required: true
        },
    },
    computed: {
        ...mapGetters('buFieldModule', [
            'allField',
            'cellsDescriptor',
            'isCellAcquisto',
            'isCellVendita',
            'isCellRe',
            'isCellNe',
        ]),
    }
})
export default class AttivitaTimesheet extends Vue {
    lista: any = setup(() => Lista(businessUnitAttivitaTimesheetVociSpesaManager, this.cols));
    id!: number

    bu = {
        nome: '',
        id: 0,
        created_at: null,
        updated_at: null,
        label: '',
        show_crm: false,
        show_progetti: false,
        bu_father_id: null,
        field_default: '',
        PD1G_CODICE: '',
        controllore_user_id: null
    }
    esito = false
    response_message = ''
    errors = {}

    created() {
        this.lista.fetchData()
    }

    save() {

    }

    cols = [
        {
            name: 'Attivita timesheet',
            prop: 'attivita_timesheet_descrizione',
            orderable: true,
            ordProp: 'attivita_timesheet.descrizione',
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Business unit',
            prop: 'business_units_nome',
            ordProp: 'business_units.nome',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Voce di spesa',
            prop: 'voci_spesa_descrizione',
            ordProp: 'voci_spesa.descrizione',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]

}

</script>


<style lang="scss">

</style>
